<template>
  <BaseNuxtImage
    v-editable="blok"
    loading="eager"
    :src="src"
    :alt="blok.photo.alt"
    class="collage-photo"
    :class="[
      sizeClass,
      alignmentClass,
      { 'collage-photo--round': blok.round_edges },
    ]"
  />
</template>

<script lang="ts" setup>
import type { SbCollagePhoto } from '@/types'

interface Props {
  blok: SbCollagePhoto
}

const props = defineProps<Props>()

const src = computed(() => props.blok.photo?.filename)
const sizeClass = computed(() => `collage-photo--${props.blok.size || 'sm'}`)
const alignmentClass = computed(
  () => `collage-photo--${props.blok.alignment || ''}`,
)
</script>

<style lang="scss" scoped>
.collage-photo {
  width: 100%;
  object-fit: cover;
  height: auto;

  &--sm {
    grid-column: span 2;
  }

  &--md {
    grid-column: span 4;
  }

  &--lg {
    grid-column: span 6;
  }

  &--round {
    border-radius: 26px;
  }

  &--start {
    align-self: start;
  }

  &--center {
    align-self: center;
  }

  &--end {
    align-self: end;
  }

  &--stretch {
    align-self: stretch;
  }
}
</style>
